import { render, staticRenderFns } from "./MaxBookingCount.vue?vue&type=template&id=4d551324&scoped=true"
import script from "./MaxBookingCount.vue?vue&type=script&lang=js"
export * from "./MaxBookingCount.vue?vue&type=script&lang=js"
import style0 from "./MaxBookingCount.vue?vue&type=style&index=0&id=4d551324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d551324",
  null
  
)

export default component.exports